import styled, { from } from 'theme';

export const EnvSelectWrapper = styled.div`
  ${from('md')} {
    margin-top: -0.25rem;
  }
`;

export const EnvSelectOptions = styled.div`
  > *:not(:last-child) {
    margin-right: 1rem;
  }
`;

export const ErrorMessage = styled.p`
  margin-top: 0.2187rem;
  color: ${props => props.theme.variables.colors.red};
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
`;
